import { useState } from 'react';
import { Comment } from './comment';
import { CommentInput } from './commentInput';
import { formatDistanceToNow } from 'date-fns';
import { InteractionsResponse, ProfileResponse } from '../../../store/backendApi';
import { LikeButton } from '../likeButton';

export interface Comment {
  name?: string;
  userId?: string;
  body: string;
  id: string;
  createdAt: string;
}

export interface CommentTextFieldProps {
  tripId: string;
  storyId: string;
  comments: Comment[] | undefined;
  linkSecret: string | null;
  profile?: ProfileResponse | null;
  interactions: InteractionsResponse | undefined;
  isOwner: boolean;
}

export const CommentSection = (props: CommentTextFieldProps) => {
  const [open, setOpen] = useState(false);

  const hasComments = !!props.comments && props.comments.length > 0;
  const buttonText = open ? 'Hide Comments' : 'Comments';

  return (
    <div className="flex flex-col items-center">
      <div className="flex gap-4">
        <LikeButton
          tripId={props.tripId}
          storyId={props.storyId}
          linkSecret={props.linkSecret}
          interactions={props.interactions}
          profile={props.profile}
        />
        <button
          className="px-4 py-2 text-sm bg-gray-200 text-gray-700 hover:bg-gray-300 rounded"
          onClick={() => setOpen((prev) => !prev)}
        >
          {buttonText}
        </button>
      </div>
      {open && (
        <section className="mt-4 w-[80vw] max-w-[500px]">
          <div className="w-full flex-col justify-start items-start gap-3 flex">
            <div className="w-full flex-col justify-start items-end gap-1 flex">
              {!hasComments && <p className="w-full text-center">No comment yet</p>}
              {hasComments &&
                props.comments
                  ?.slice()
                  .sort(
                    (c1, c2) => new Date(c2.createdAt).getTime() - new Date(c1.createdAt).getTime(),
                  )
                  .map((comment) => (
                    <Comment
                      key={comment.id}
                      id={comment.id}
                      name={comment.name}
                      userId={comment.userId}
                      body={comment.body}
                      timeText={formatDistanceToNow(new Date(comment.createdAt), {
                        addSuffix: true,
                      })}
                      tripId={props.tripId}
                      isOwner={props.isOwner}
                    />
                  ))}
            </div>
            <CommentInput
              storyId={props.storyId}
              tripId={props.tripId}
              profile={props.profile}
              linkSecret={props.linkSecret}
            />
          </div>
        </section>
      )}
    </div>
  );
};
